@if (currentTab != null) {
  <bolt-progress-bar value="{{progressBarPercentage}}" class="mobiles-only"></bolt-progress-bar>
}
<section role="region" aria-label="Claim steps">
  @if (currentTab != null) {
    <bolt-tabset class="mobiles-only">
      <bolt-tablabel class="bolt-row bolt-w-100 progress-bar-header">
        <div class="bolt-col-10">
          @if (!menu) {
            <p class="currentTab">{{currentTab}}</p>
          }
          @if (!menu) {
            <p class="currentSubTab">{{currentTabSection}}</p>
          }
          @if (menu) {
            <p class="extendedHeader">Your claims progress</p>
          }
        </div>
        <div class="align-icons bolt-heading-md bolt-col-1 bolt-justify-content-center">
          @if (!menu) {
            <bolt-icon name="chevron-down" color="black" (click)="showDropDown()"></bolt-icon>
          }
          @if (menu) {
            <bolt-icon name="chevron-up" color="black" (click)="showDropDown()"></bolt-icon>
          }
        </div>
      </bolt-tablabel>
      @if (menu) {
        <bolt-tabpanel class="progress-bar-menu">
          <div class="bolt-w-100 bolt-row" [ngClass]="{'expanded-background' : showBasicInfo}"
            (click)="showSubMenus(tabsList[0].title)">
            <div class="bolt-col-6">
              <p class="tab-title">{{tabsList[0].title}}</p>
            </div>
            @if (!showBasicInfo) {
              <bolt-icon class="bolt-col-6" name="plus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
            @if (showBasicInfo) {
              <bolt-icon class="bolt-col-6" name="minus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
          </div>
          @if (showBasicInfo) {
            <div  class="expanded-background">
              @for (item of basicInfoList; track item) {
                <div class="sub-menu-wrapper">
                  <div class="bolt-row bolt-w-100 sub-menu-item">
                    @if (item.past) {
                      <bolt-icon name="checkmark" color="blue"></bolt-icon>
                    }
                    <div [ngClass]="{'current-circle' : item.current,'future-circle': item.future}"></div>
                    @if (!item.current) {
                      <p class="title" [ngClass]="{'current-title' : item.past,'future-title': item.future}">{{item.title}}</p>
                    }
                    @if (item.current) {
                      <p class="title"><strong>{{item.title}}</strong></p>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="bolt-w-100 bolt-row" [ngClass]="{'expanded-background' : showIncidentDetail}"
            (click)="showSubMenus(tabsList[1].title)">
            <div class="bolt-col-6">
              <p class="tab-title">{{tabsList[1].title}}</p>
            </div>
            @if (!showIncidentDetail) {
              <bolt-icon class="bolt-col-6" name="plus" color="mediumBlue" class="align-icons" ></bolt-icon>
            }
            @if (showIncidentDetail) {
              <bolt-icon class="bolt-col-6" name="minus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
          </div>
          @if (showIncidentDetail) {
            <div class="expanded-background">
              @for (item of accidentDetailsList; track item) {
                <div class="sub-menu-wrapper">
                  <div class="bolt-row bolt-w-100 sub-menu-item">
                    @if (item.past) {
                      <bolt-icon name="checkmark" color="mediumBlue"></bolt-icon>
                    }
                    <div [ngClass]="{'current-circle' : item.current,'future-circle': item.future}"></div>
                    @if (!item.current) {
                      <p class="title" [ngClass]="{'current-title' : item.past,'future-title': item.future}">{{item.title}}</p>
                    }
                    @if (item.current) {
                      <p class="title"><strong>{{item.title}}</strong></p>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="bolt-w-100 bolt-row" [ngClass]="{'expanded-background' : showServices}"
            (click)="showSubMenus(tabsList[2].title)">
            <div class="bolt-col-6">
              <p class="tab-title">{{tabsList[2].title}}</p>
            </div>
            @if (!showServices) {
              <bolt-icon class="bolt-col-6" name="plus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
            @if (showServices) {
              <bolt-icon class="bolt-col-6" name="minus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
          </div>
          @if (showServices) {
            <div  class="expanded-background">
              @for (item of servicesList; track item) {
                <div class="sub-menu-wrapper">
                  <div class="bolt-row bolt-w-100 sub-menu-item">
                    @if (item.past) {
                      <bolt-icon name="checkmark" color="mediumBlue"></bolt-icon>
                    }
                    <div [ngClass]="{'current-circle' : item.current,'future-circle': item.future}"></div>
                    @if (!item.current) {
                      <p class="title" [ngClass]="{'current-title' : item.past,'future-title': item.future}">{{item.title}}</p>
                    }
                    @if (item.current) {
                      <p class="title"><strong>{{item.title}}</strong></p>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="bolt-w-100 bolt-row" [ngClass]="{'expanded-background' : showSummary}"
            (click)="showSubMenus(tabsList[3].title)">
            <div class="bolt-col-6">
              <p class="tab-title">{{tabsList[3].title}}</p>
            </div>
            @if (!showSummary) {
              <bolt-icon class="bolt-col-6" name="plus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
            @if (showSummary) {
              <bolt-icon class="bolt-col-6" name="minus" color="mediumBlue" class="align-icons"></bolt-icon>
            }
          </div>
          @if (showSummary) {
            <div  class="expanded-background">
              @for (item of claimsSummaryList; track item) {
                <div class="sub-menu-wrapper">
                  <div class="bolt-row bolt-w-100 sub-menu-item">
                    @if (item.past) {
                      <bolt-icon name="checkmark" color="mediumBlue"></bolt-icon>
                    }
                    <div [ngClass]="{'current-circle' : item.current,'future-circle': item.future}"></div>
                    @if (!item.current) {
                      <p class="title" [ngClass]="{'current-title' : item.past,'future-title': item.future}">{{item.title}}</p>
                    }
                    @if (item.current) {
                      <p class="title"><strong>{{item.title}}</strong></p>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </bolt-tabpanel>
      }
    </bolt-tabset>
  }
</section>

@if (currentTab != null) {
  <div class="desktops-only" role="region">
    <bolt-tabset class="bolt-row tabs">
      @for (tab of tabsList; track tab) {
        <bolt-tablabel class="bolt-col-3 no-hover" (click)="changeTab(tab.title)">
          @if (tab.completed && tab.Current) {
            <div  class="bolt-row no-margin selected-tab" (click)="changeTab(tab.title)">
              <bolt-icon class="completed-checkmark" name="checkmark" color="mediumBlue" aria-label="Completed step"></bolt-icon>
              @if (tab.Current) {
                <p aria-selected="true">{{tab.title}}</p>
              }
            </div>
          }
          @if (tab.completed && tab.unselectedPast) {
            <div  class="bolt-row no-margin unselected-past-tab">
              <bolt-icon class="completed-checkmark" name="checkmark" color="mediumBlue" aria-label="Completed step"></bolt-icon>
              <p>{{tab.title}}</p>
            </div>
          }
          @if (tab.completed && tab.unselectedFuture) {
            <div  class="bolt-row no-margin unselected-future-tab">
              <bolt-icon class="completed-checkmark" name="checkmark" color="mediumBlue" aria-label="Completed step"></bolt-icon>
              <p class="unselected-future-tab">{{tab.title}}</p>
            </div>
          }
          @if (tab.unselectedPast && !tab.completed) {
            <p class="center unselected-past-tab">{{tab.title}}</p>
          }
          @if (tab.Current && !tab.completed) {
            <p class="center selected-tab">{{tab.title}}</p>
          }
          @if (tab.unselectedFuture && !tab.completed) {
            <p class="center unselected-future-tab">{{tab.title}}</p>
          }
        </bolt-tablabel>
      }
      <bolt-tabpanel class="bolt-row sub-menu">
        @for (item of list; track item; let i = $index; let isLast = $last) {
          <div class="bolt-row sub-menu-repeator">
            @if (item.past) {
              <bolt-icon
                name="checkmark"
                color="mediumBlue">
              </bolt-icon>
            }
            @if (item.current) {
              <bolt-icon
                class="current-circle"
                style= "color:#0067c5;">
              </bolt-icon>
            }
            @if (item.future) {
              <bolt-icon
                class="future-circle"
                style= "color:#afa9a0;">
              </bolt-icon>
            }
            <p [ngClass]="{'current-title' : item.current,'future-title': item.future}">{{item.title}}</p>
            @if (!isLast) {
              <div class="line-between"></div>
            }
          </div>
        }
      </bolt-tabpanel>
    </bolt-tabset>
  </div>
}
